<template>
  <el-form
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    label-width="120px"
    class="
      demo-ruleForm
      choose-car-filters
      mb-4
      grid grid-cols-1
      gap-4
      md:grid-cols-2
      lg:grid-cols-4
      xl:grid-cols-8
    "
    @mouseover.native="showOverflowTip"
    @mouseout.native="hideOverflowTip"
  >
    <VehicleSelect
      :loading="loading"
      prop="company_vehicle.id"
      :model="ruleForm.company_vehicle.id"
      @update="vehicleChange($event)"
      @totalCount="totalCount = $event"
      :disabled="ruleForm.disabled"
      :multiple="true"
      :collapseTags="true"
      class="xl:col-span-2"
    />

    <el-form-item
      class="xl:col-span-2"
      :label="$t('VEHCILE_NAME')"
      prop="vehicle.id"
      v-loading="vehicleLoading"
      element-loading-spinner="el-icon-loading"
    >
      <el-select
        :disabled="ruleForm.disabled"
        :placeholder="$t('SELECT_PLACEHOLDER')"
        v-model="ruleForm.vehicle.id"
        :multiple="true"
        :collapseTags="true"
        clearable
        filterable
        @change="vehicleNameChange"
      >
        <el-option-group
          v-for="group in carList"
          :key="group.id"
          :label="$i18n.locale == 'fa' ? group.fa_title : group.en_title"
        >
          <el-option
            v-for="item in group.vehicles"
            :key="item.id"
            :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
            :value="item.id"
          ></el-option>
        </el-option-group>
      </el-select>
    </el-form-item>

    <el-form-item class="xl:col-span-1" :label="$t('STATUS')" prop="status">
      <el-select
        :multiple="true"
        :collapseTags="true"
        :placeholder="$t('SELECT_PLACEHOLDER')"
        v-model="ruleForm.status"
        clearable
        filterable
        @change="statusChanged"
      >
        <el-option
          v-for="(item, index) in statuses"
          :key="index"
          :label="item.title"
          :value="item.value"
        >
          <template>
            <span class="flex items-center gap-2">
              <span
                class="prefix w-2 h-2 rounded-full border border-gray-200"
                :style="`background-color: ${item.color}`"
              ></span>
              {{ item.title }}
            </span>
          </template>
        </el-option>
      </el-select>
    </el-form-item>
    <VehicleTag @tags="tagChanged" :value="ruleForm.company_vehicle_tags" />

    <span
      class="text-gray-400 text-xs pt-3 lg:flex lg:absolute lg:top-2.5 hidden"
      :class="{
        'lg:left-4': $i18n.locale == 'fa',
        'lg:right-4': $i18n.locale != 'fa',
      }"
    >
      {{ $t('VEHICLE_COUNT') }} : {{ totalCount }}
    </span>

    <el-form-item class="flex justify-end xl:col-start-7 xl:col-span-2">
      <el-button type="info" @click="resetMap">
        {{ $t('SHOW_ALL') }}
      </el-button>
    </el-form-item>

    <el-tooltip
      effect="dark"
      :content="overflowLabel"
      placement="top"
      manual
      v-model="overflowVisible"
    >
      <span ref="tagAnchor" class="choose-car-tag-anchor"></span>
    </el-tooltip>
  </el-form>
</template>

<script>
import VehicleTag from '@/components/elements/vehcileTag.vue'
import VehicleSelect from '@/components/elements/vehiclesSelect.vue'
import { carsList } from '@/api/global'
export default {
  data() {
    return {
      ruleForm: {
        company_vehicle: {
          id: '',
        },
        company_vehicle_tags: [],
        status: [],
        vehicle: {
          id: [],
        },
      },
      carList: [],
      vehicleLoading: true,
      totalCount: 0,
      loading: true,
      vehicles: null,
      rules: {},
      overflowLabel: '',
      overflowVisible: false,
      statuses: [
        {
          title: this.$t('ONLINE'),
          value: 'online',
          color: '#67C23A',
        },
        {
          title: this.$t('MOVING'),
          value: 'moving',
          color: '#67C23A',
        },
        {
          title: this.$t('idle_vehcile'),
          value: 'idle',
          color: 'darkred',
        },
        {
          title: this.$t('STOPPED'),
          value: 'stopped',
          color: 'grey',
        },
        {
          title: this.$t('orange_point'),
          value: 'offline',
          color: '#f59e0b',
        },
      ],
    }
  },
  components: {
    VehicleSelect,
    VehicleTag,
  },
  methods: {
    vehicleChange(id) {
      this.ruleForm.company_vehicle.id = id
      this.vehicles = id.join(',')
      // Automatically commit to store
      this.$store.commit(
        'SET_VEHCILE_LIST',
        id.length == this.totalCount ? null : this.vehicles
      )
    },
    vehicleNameChange(ids) {
      const vehicleNameValue = ids && ids.length ? ids.join(',') : null
      this.$store.commit('SET_VEHICLE_NAME', vehicleNameValue)
    },
    tagChanged(val) {
      this.ruleForm.company_vehicle_tags = val
      // Automatically commit to store
      this.$store.commit('SET_VEHCILE_TAGS', val)
    },
    statusChanged(val) {
      // Automatically commit to store
      this.$store.commit('SET_VEHCILE_STATUS', val)
    },

    resetAllFilters() {
      // Reset all form fields
      this.ruleForm.company_vehicle.id = ''
      this.ruleForm.company_vehicle_tags = []
      this.ruleForm.status = []
      this.ruleForm.vehicle.id = []

      // Reset component state
      this.vehicles = null

      // Reset store state
      this.$store.commit('SET_VEHCILE_LIST', null)
      this.$store.commit('SET_VEHCILE_TAGS', [])
      this.$store.commit('SET_VEHCILE_STATUS', [])
      this.$store.commit('SET_VEHICLE_NAME', null)
    },
    resetMap() {
      this.selectAll()
      this.$store.commit('SET_VEHCILE_LIST', null)
      this.$store.commit('SET_VEHCILE_TAGS', [])
      this.$store.commit('SET_VEHCILE_STATUS', [])
      this.$store.commit('SET_VEHICLE_NAME', null)
      // Force reactive update for VehicleTag component
      this.$nextTick(() => {
        this.ruleForm.company_vehicle_tags = []
      })
    },
    selectAll() {
      // Reset all form fields
      this.ruleForm.company_vehicle.id = ''
      this.ruleForm.company_vehicle_tags = []
      this.ruleForm.status = []
      this.ruleForm.vehicle.id = []
      // Reset component state
      this.vehicles = null
    },
    showOverflowTip(event) {
      const text = event.target.closest
        ? event.target.closest('.el-select__tags-text')
        : null
      if (!text || text.scrollWidth <= text.clientWidth + 1) {
        this.hideOverflowTip(event)
        return
      }

      const label = text.textContent.trim()
      if (this.overflowVisible && this.overflowLabel === label) return

      const rect = text.getBoundingClientRect()
      const anchor = this.$refs.tagAnchor
      anchor.style.left = `${rect.left}px`
      anchor.style.top = `${rect.top}px`
      anchor.style.width = `${rect.width}px`
      anchor.style.height = `${rect.height}px`
      this.overflowLabel = label
      this.overflowVisible = false
      this.$nextTick(() => {
        this.overflowVisible = true
      })
    },
    hideOverflowTip(event) {
      const next = event && event.relatedTarget
      if (next && next.closest && next.closest('.el-select__tags-text')) return
      this.overflowVisible = false
    },
  },
  created() {
    carsList.api().then((res) => {
      if (res) {
        this.vehicleLoading = false
        this.carList = res
      }
    })
  },
}
</script>

<style lang="scss">
.choose-car-filters {
  .el-select {
    width: 100%;
  }

  .el-select__tags {
    flex-wrap: nowrap;
    overflow: hidden;
    max-width: calc(100% - 30px);
  }

  .el-select__tags > span {
    display: inline-flex;
    align-items: center;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
  }

  .el-select__tags .el-tag {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    box-sizing: border-box;
  }

  .el-select__tags .el-tag:first-child {
    flex: 1 1 auto;
  }

  .el-select__tags .el-tag + .el-tag {
    flex: 0 0 auto;
  }

  .el-select__tags-text {
    display: block;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.choose-car-tag-anchor {
  position: fixed;
  z-index: -1;
  pointer-events: none;
}
</style>
